import { render, staticRenderFns } from "./AtpFeed.vue?vue&type=template&id=4892ae84&scoped=true"
import script from "./AtpFeed.vue?vue&type=script&lang=js"
export * from "./AtpFeed.vue?vue&type=script&lang=js"
import style0 from "./AtpFeed.vue?vue&type=style&index=0&id=4892ae84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4892ae84",
  null
  
)

export default component.exports